export default __webpack_public_path__ + "sql-wasm-057823fecaede6350cf9941c7d4c7ce3.wasm";